import { Divider } from '@mui/material';

import React from 'react';
import { useTranslation } from 'react-i18next';
import { AmenityProps, OperatorProps, TransitProps } from 'src/common/api/response';
import { CardContainer, NewAmenities, RegularText, Row, SmallOperator } from 'src/components';
import { TimeLine } from 'src/components/layout/Timeline';
import { AppColors } from 'src/themes/Colors';
import { metrics, pixelScaler } from 'src/themes/Metrics';

export const BusDetailsCard = ({
  operator,
  service,
  transits,
  amenities,
}: {
  operator?: OperatorProps;
  service?: string;
  transits: TransitProps[] | [];
  amenities: AmenityProps[];
}) => {
  const { t } = useTranslation();

  return (
    <CardContainer paddingVertical={pixelScaler(20)}>
      <RegularText fontWeight="bold" fontSize="large">
        {t('busDetails')}
      </RegularText>
      <Row marginTop={metrics.large} style={{ justifyContent: 'space-between', alignItems: 'center' }}>
        <SmallOperator operator={operator} />
        <RegularText color={AppColors.gray}>{service}</RegularText>
      </Row>
      <Divider style={{ marginTop: metrics.medium, marginBottom: metrics.large }} />
      <TimeLine transits={transits} />
      <Divider style={{ marginTop: pixelScaler(4), marginBottom: metrics.large }} />
      <NewAmenities hideTitle amenities={amenities} />
    </CardContainer>
  );
};
